webpackJsonp([165],{

/***/ 1187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUploadTable_vue__ = __webpack_require__(2896);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16287ceb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUploadTable_vue__ = __webpack_require__(5125);
function injectStyle (ssrContext) {
  __webpack_require__(5119)
  __webpack_require__(5121)
  this["$style"] = __webpack_require__(5123)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16287ceb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUploadTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16287ceb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUploadTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SjProgress',
  data: function data() {
    return {
      type: 'line'
    };
  },

  props: {
    percentages: {
      type: Array,
      default: []
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    textInside: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: true
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    barParts: function barParts() {
      var result = [];
      for (var i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result.push(this.percentages[i]);
        }
      }
      return result;
    },
    percentage: function percentage() {
      var result = 0;
      for (var i in this.percentages) {
        if (this.percentages.hasOwnProperty(i) && this.percentages[i].width > 0) {
          result += this.percentages[i].width;
        }
      }
      return result;
    },
    iconClass: function iconClass() {
      switch (this.status) {
        case 'success':
          return 'el-icon-circle-check';
        case 'error':
        case 'exception':
          return 'el-icon-circle-close';
        case 'ongoing':
          return 'el-icon-loading';
      }
    }
  },
  methods: {
    getColor: function getColor(status) {
      var ret = void 0;
      switch (status) {
        case 'success':
          ret = '#13ce66';
          break;
        case 'exception':
        case 'error':
          ret = '#f56c6c';
          break;
        default:
          ret = '#20a0ff';
      }
      return ret;
    },
    barStyle: function barStyle(part, index, parts) {
      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        backgroundColor: part.status ? this.getColor(part.status) : part.color,
        borderRadius: 'none',
        display: 'inline-block',
        position: 'relative'
      }, part);

      style.width = part.width + '%';

      if (parts.length === 1) {
        style.borderRadius = '100px';
      }

      if (parts.length > 1 && index === 0) {
        style.borderRadius = '100px 0 0 100px';
      }

      if (parts.length > 1 && index + 1 === parts.length) {
        style.borderRadius = '0 100px 100px 0';
      }

      return style;
    }
  }
});

/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjProgress_vue__ = __webpack_require__(1388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17698c40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjProgress_vue__ = __webpack_require__(1439);
function injectStyle (ssrContext) {
  __webpack_require__(1437)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17698c40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17698c40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1437:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6cddd4f7", content, true, {});

/***/ }),

/***/ 1438:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".el-progress.is-error .el-progress__text[data-v-17698c40]{color:#f56c6c}.el-progress-bar[data-v-17698c40]{padding-right:30px;margin-right:-30px}", "", {"version":3,"sources":["/workspace/src/components/sj-progress/SjProgress.vue"],"names":[],"mappings":"AACA,0DAA0D,aAAa,CACtE,AACD,kCAAkC,mBAAmB,kBAAkB,CACtE","file":"SjProgress.vue","sourcesContent":["\n.el-progress.is-error .el-progress__text[data-v-17698c40]{color:#f56c6c\n}\n.el-progress-bar[data-v-17698c40]{padding-right:30px;margin-right:-30px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-progress",class:[
    'el-progress--' + _vm.type,
    _vm.status ? 'is-' + _vm.status : '',
    {
      'el-progress--without-text': _vm.status === '',
      'el-progress--text-inside': _vm.status === '',
    }
  ],attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.type === 'line')?_c('div',{staticClass:"el-progress-bar"},[_c('div',{staticClass:"el-progress-bar__outer",style:({height: _vm.strokeWidth + 'px'})},_vm._l((_vm.barParts),function(part,index){return _c('div',{staticClass:"el-progress-bar__inner",style:(_vm.barStyle(part, index, _vm.barParts))},[(_vm.showText && _vm.textInside)?_c('div',{staticClass:"el-progress-bar__innerText"},[_vm._v(_vm._s(part.width)+"%\n        ")]):_vm._e()])}),0)]):_vm._e(),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"el-progress__text"},[_c('i',{class:_vm.iconClass})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_downloadjs__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onDownErrorFile: function onDownErrorFile(id) {
      __WEBPACK_IMPORTED_MODULE_0_downloadjs___default()(request.items.downErrorFile(id));
    },
    taskBatchPercentage: function taskBatchPercentage(row) {
      var parts = [];
      if (row.total_count <= 0) {
        return parts;
      }

      var success = 0;
      var error = 0;

      if (row.success_count > 0) {
        success = Math.round(row.success_count * 100 / row.total_count);
      }

      if (row.error_count > 0) {
        error = Math.round(row.error_count * 100 / row.total_count);
      }

      if (success + error > 100) {
        error = 100 - success;
      }

      if (success > 0) {
        parts.push({
          width: success,
          status: 'default'
        });
      }

      if (error > 0) {
        parts.push({
          width: error,
          status: 'error'
        });
      }

      return parts;
    },
    taskBatchStatus: function taskBatchStatus(row) {
      switch (row.status) {
        case 1:
        case 2:
          return 'ongoing';
        case 3:
          return 'success';
        case -1:
        case -2:
        case -3:
        case -4:
          return 'error';
      }
    }
  }
});

/***/ }),

/***/ 1444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SjProgress__ = __webpack_require__(1436);


__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SjProgress__["a" /* default */]);

/***/ }),

/***/ 2896:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sj_progress__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_task_batch_task_batch_mixins__ = __webpack_require__(1440);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_4__views_task_batch_task_batch_mixins__["a" /* default */]],
  components: { SjProgress: __WEBPACK_IMPORTED_MODULE_3__components_sj_progress__["a" /* default */] },
  data: function data() {
    return {
      options: {
        task_type: [{ value: 212, label: '批量角色添加' }, { value: 213, label: '批量角色删除' }, { value: 233, label: '批量更新平台用户邮箱' }, { value: 263, label: '批量添加平台用户' }, { value: 264, label: '批量编辑平台用户' }]
      },
      search: {
        collection_type: 8,
        number: this.$route.params.number || ''
      }
    };
  },

  computed: Vuex.mapState({
    status: function status(state) {
      return state.taskBatch.status;
    },
    users: function users(state) {
      return state.login.user;
    }
  }),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.common('queryBatchUpload', params);
    },
    onDownSourceFile: function onDownSourceFile(id) {
      __WEBPACK_IMPORTED_MODULE_2_downloadjs___default()(request.items.downSourceFile(id));
    },
    onDownErrorFile: function onDownErrorFile(id) {
      __WEBPACK_IMPORTED_MODULE_2_downloadjs___default()(request.items.downErrorFile(id));
    },
    onUnprocessFile: function onUnprocessFile(id) {
      __WEBPACK_IMPORTED_MODULE_2_downloadjs___default()(request.items.downUnprocessFile(id));
    },
    onUploadFile: function onUploadFile(file, type) {
      var isLt10M = file.raw.size / 1024 / 1024 < 5;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      if (type === 1) {
        this.batchUploadAddRole(formData);
      } else if (type === 2) {
        this.batchUploadDelRole(formData);
      } else if (type === 3) {
        this.batchUploadUpdateEmail(formData);
      } else if (type === 4) {
        this.uploadSJIdCardRegionFile(formData);
      } else {
        return false;
      }
    },
    batchUploadAddRole: function batchUploadAddRole(formData) {
      var _this = this;

      request.common('batchUploadAddRole', formData).then(function (_ref) {
        var data = _ref.data;

        _this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this.onSearch();
      });
    },
    batchUploadDelRole: function batchUploadDelRole(formData) {
      var _this2 = this;

      request.common('batchUploadDelRole', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this2.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this2.onSearch();
      });
    },
    batchUploadUpdateEmail: function batchUploadUpdateEmail(formData) {
      var _this3 = this;

      request.common('batchUploadUpdateEmail', formData).then(function (_ref3) {
        var data = _ref3.data;

        _this3.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this3.onSearch();
      });
    },
    onClickUpload: function onClickUpload(e, refName) {
      e.stopPropagation();
      this.$refs[refName].$refs['upload-inner'].handleClick();
    },
    downloadAddUserDemo: function downloadAddUserDemo() {
      this.$export('批量添加实习生', [{
        'name': '刘某人',
        'phone': '15623450851',
        'mail_address': 'jake@so-in.com',
        'status': '活跃|待机|离职',
        'department_name': '公关部',
        'desc': '',
        'customerid': '123,982,81',
        'role_ids': '981,93,123',
        'permission_ids': '981,93,123'
      }, {
        'name': '手机号必填，其他需修改字段按需添加，更新方式为覆盖更新，单元格为空时跳过不更新'
      }, {
        'name': '提示：上传时请删除示例数据'
      }], {
        fileHeader: [{
          key: 'name',
          text: '用户名'
        }, {
          key: 'phone',
          text: '手机号'
        }, {
          key: 'mail_address',
          text: '邮箱'
        }, {
          key: 'status',
          text: '状态'
        }, {
          key: 'department_name',
          text: '部门'
        }, {
          key: 'desc',
          text: '备注'
        }, {
          key: 'customerid',
          text: '客户权限'
        }, {
          key: 'role_ids',
          text: '角色权限'
        }, {
          key: 'permission_ids',
          text: 'UI角色权限'
        }]
      });
    },
    onUploadAdminUserFile: function onUploadAdminUserFile(file, taskType, ref) {
      var _this4 = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs[ref].clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 8);
      formData.append('type', taskType);

      request.common('createTaskBatch', formData).then(function (_ref4) {
        var data = _ref4.data;

        _this4.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this4.onSearch({});
      });
    },
    uploadSJIdCardRegionFile: function uploadSJIdCardRegionFile(formData) {
      var _this5 = this;

      request.common('uploadSJIdCardRegionFileApi', formData).then(function (_ref5) {
        var data = _ref5.data;

        _this5.$message.success('身份证行政区划文件上传成功');
      });
    },
    downloadSJIdCardRegionFile: function downloadSJIdCardRegionFile() {
      var _this6 = this;

      var fileHeader = [{ key: 'code', text: '行政区划代码' }, { key: 'name', text: '单位名称' }];
      var regions = [];
      request.common('getSJIdCardRegionFileApi', {}).then(function (_ref6) {
        var data = _ref6.data;

        for (var code in data) {
          regions.push({ code: code, name: data[code] });
        }
        _this6.$export('身份证行政区划当前数据文件', regions, { fileHeader: fileHeader });
      });
    }
  })
});

/***/ }),

/***/ 5119:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5120);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("17caa8d5", content, true, {});

/***/ }),

/***/ 5120:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformUploadTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5121:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5122);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("59582dcd", content, true, {});

/***/ }),

/***/ 5122:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".task-upload-buttons[data-v-16287ceb]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;row-gap:10px;margin-bottom:10px}.task-upload-buttons>div[data-v-16287ceb]{margin-right:20px}", "", {"version":3,"sources":["/workspace/src/views/platform-upload/pages/PlatformUploadTable.vue"],"names":[],"mappings":"AACA,sCAAsC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,aAAa,kBAAkB,CAC3J,AACD,0CAA0C,iBAAiB,CAC1D","file":"PlatformUploadTable.vue","sourcesContent":["\n.task-upload-buttons[data-v-16287ceb]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;row-gap:10px;margin-bottom:10px\n}\n.task-upload-buttons>div[data-v-16287ceb]{margin-right:20px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5123:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4aedce4b", content, true, {});

/***/ }),

/***/ 5124:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformUploadTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("平台管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"task-upload-buttons"},[_c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"on-change":function (query) { return _vm.onUploadFile(query,1); },"accept":".xlsx,.xls","show-file-list":false}},[_c('el-button',{attrs:{"icon":"sj-icon-add","type":"primary","size":"mini"}},[_vm._v("批量添加平台用户角色\n            ")])],1)],1),_vm._v(" "),_c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"on-change":function (query) { return _vm.onUploadFile(query,2); },"accept":".xlsx,.xls","show-file-list":false}},[_c('el-button',{attrs:{"icon":"sj-icon-add","type":"primary","size":"mini"}},[_vm._v("批量删除平台用户角色\n          ")])],1)],1),_vm._v(" "),_c('div',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"on-change":function (query) { return _vm.onUploadFile(query,3); },"accept":".xlsx,.xls","show-file-list":false}},[_c('el-button',{attrs:{"icon":"sj-icon-add","type":"primary","size":"mini"}},[_vm._v("批量更新平台用户邮箱\n            ")])],1)],1),_vm._v(" "),(_vm.users.usertype + '' === '1')?_c('div',[_c('el-dropdown',{attrs:{"split-button":"","type":"primary","size":"mini","trigger":"click"},on:{"click":function (e) { return _vm.onClickUpload(e, 'uploadSJIdCardRegion'); }}},[_c('span',[_vm._v("上传身份证行政区划")]),_vm._v(" "),_c('el-upload',{ref:"uploadSJIdCardRegion",staticStyle:{"display":"none"},attrs:{"action":"","accept":".xlsx","auto-upload":false,"on-change":function (query) { return _vm.onUploadFile(query, 4); },"show-file-list":false}}),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"default"},slot:"default"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.downloadSJIdCardRegionFile($event)}}},[_vm._v("下载当前数据")])],1)],1)],1):_vm._e()]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"display_name","label":"名称","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticStyle:{"cursor":"pointer","color":"rgb(88,157,248)"},on:{"click":function($event){return _vm.onDownSourceFile(scope.row.id)}}},[_vm._v(_vm._s(scope.row.display_name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"admin_name","label":"发起者","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"上传时间","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"任务进度","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('sj-progress',{attrs:{"text-inside":true,"stroke-width":18,"status":_vm.taskBatchStatus(scope.row),"percentages":_vm.taskBatchPercentage(scope.row)}}),_vm._v("\n            成功:"+_vm._s(scope.row.success_count)+" 错误:"+_vm._s(scope.row.error_count)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"task_type","label":"类型","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.task_type),function(item){return (scope.row.task_type === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.status),function(item){return (scope.row.status === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [((scope.row.status === 3 && scope.row.error_count > 0) || scope.row.status === -2)?_c('span',[_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":function($event){return _vm.onDownErrorFile(scope.row.id)}}},[_vm._v("下载错误行")])],1):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/platform-upload-table.2f85c1f9de227d71f014.js